// https://jasonwatmore.com/post/2020/04/28/angular-9-user-registration-and-login-example-tutorial
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '@app/services';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authService: AuthService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const user = this.authService.userValue;
        if (user) {
            // authorised so return true
            return true;
        }

        // not logged in so redirect to login page (with the return url)
        this.router.navigate(['/auth/login'], { queryParams: { returnUrl: '' }});
        return true;
    }
}
